'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuex = require('vuex');

var _FrameSelections = require('./FrameSelections');

var _FrameSelections2 = _interopRequireDefault(_FrameSelections);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "Frame",
  components: {
    FrameSelections: _FrameSelections2.default
  },
  computed: Object.assign({}, (0, _vuex.mapState)({
    frame: function frame(state) {
      return state.prescription.frame;
    }
  })),
  methods: {
    addDetail: function addDetail(frame) {
      console.log(frame);
    }
  }
};